
import { RavenErrorHandler } from './raven';
import { NgModule, ApplicationRef, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { FormsModule , ReactiveFormsModule} from '@angular/forms';
// import {NgxImageSwapModule} from 'ngx-image-swap';


import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatStepperModule
} from '@angular/material';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
// Layout
import { LayoutComponent } from './layout/layout.component';
import { PreloaderDirective } from './layout/preloader.directive';
// Header
import { AppHeaderComponent } from './layout/header/header.component';
// Sidenav
import { AppSidenavComponent } from './layout/sidenav/sidenav.component';
import { ToggleOffcanvasNavDirective } from './layout/sidenav/toggle-offcanvas-nav.directive';
import { AutoCloseMobileNavDirective } from './layout/sidenav/auto-close-mobile-nav.directive';
import { AppSidenavMenuComponent } from './layout/sidenav/sidenav-menu/sidenav-menu.component';
import { AccordionNavDirective } from './layout/sidenav/sidenav-menu/accordion-nav.directive';
import { AppendSubmenuIconDirective } from './layout/sidenav/sidenav-menu/append-submenu-icon.directive';
import { HighlightActiveItemsDirective } from './layout/sidenav/sidenav-menu/highlight-active-items.directive';
// Customizer
import { AppCustomizerComponent } from './layout/customizer/customizer.component';
import { ToggleQuickviewDirective } from './layout/customizer/toggle-quickview.directive';
// Footer
import { AppFooterComponent } from './layout/footer/footer.component';
// Search Overaly
import { AppSearchOverlayComponent } from './layout/search-overlay/search-overlay.component';
import { SearchOverlayDirective } from './layout/search-overlay/search-overlay.directive';
import { OpenSearchOverlaylDirective } from './layout/search-overlay/open-search-overlay.directive';

// Pages

import { PageLayoutFullscreenComponent } from './page-layouts/fullscreen/fullscreen.component';

// Sub modules
import { LayoutModule } from './layout/layout.module';
import { SharedModule } from './shared/shared.module';

// hmr
import { removeNgStyles, createNewHosts } from '@angularclass/hmr';

// Providers
import { Api } from './providers/api';
import { ApiBilling } from './providers/api.billing';
import { AuthGuardService } from './providers/auth-guard-service';



import { FileDropDirective } from './directives/file-drop';

import {APPCONFIG} from './config';
// import { FileDropModule } from 'ngx-file-drop/lib/ngx-drop';


import { TextMaskModule } from 'angular2-text-mask';
import {ToastModule} from 'ng2-toastr';

import {CsvService} from "angular2-json2csv"

import {BusyModule} from 'angular2-busy';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';

import {ngxZendeskWebwidgetModule, ngxZendeskWebwidgetConfig} from 'ngx-zendesk-webwidget';
import {LicenseFailureDialogComponent} from "./inventory/shipmentNotices/license-failure-dialog.component";
import {TransactionConsumedDialogComponent} from "./billing/home/transaction-consumed-dialog.component";
import {CustomersDialogComponent} from "./customers/home/customers-dialog.component";
import {
  ConfirmCreateCustomerWithExistingNameComponent
} from "./customers/home/ConfirmCreateCustomerWithExistingNameComponent";




export class ZendeskConfig extends ngxZendeskWebwidgetConfig {
  accountUrl = APPCONFIG.zopim_subdomain;
  beforePageLoad(zE) {
    zE.setLocale('en');
    zE.hide();
    zE.setHelpCenterSuggestions({ url: true })
    
  }
}


@NgModule({
  imports: [
    ngxZendeskWebwidgetModule.forRoot(ZendeskConfig),
    BrowserModule,
    HttpModule,
    FormsModule,
    TextMaskModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    AppRoutingModule,
    ToastModule.forRoot(),
    // Sub modules
    LayoutModule,
    SharedModule,
    BusyModule,
    SweetAlert2Module.forRoot(),
    // NgxImageSwapModule
    // FileDropModule
  ],
  declarations: [
    AppComponent,
    // Layout
    LayoutComponent,
    PreloaderDirective,
    // Header
    AppHeaderComponent,
    // Sidenav
    AppSidenavComponent,
    ToggleOffcanvasNavDirective,
    AutoCloseMobileNavDirective,
    AppSidenavMenuComponent,
    AccordionNavDirective,
    AppendSubmenuIconDirective,
    HighlightActiveItemsDirective,
    // Customizer
    AppCustomizerComponent,
    ToggleQuickviewDirective,
    // Footer
    AppFooterComponent,
    LicenseFailureDialogComponent,
    // Search overlay
    AppSearchOverlayComponent,
    SearchOverlayDirective,
    OpenSearchOverlaylDirective,
    //

    // Pages
    PageLayoutFullscreenComponent,
    TransactionConsumedDialogComponent,
      CustomersDialogComponent,
    ConfirmCreateCustomerWithExistingNameComponent
  ],
  entryComponents: [
    LicenseFailureDialogComponent,
    TransactionConsumedDialogComponent,
      CustomersDialogComponent,
    ConfirmCreateCustomerWithExistingNameComponent
  ],

  bootstrap: [AppComponent],
  providers: [{ provide: ErrorHandler, useClass: RavenErrorHandler },CsvService,ApiBilling,Api,AuthGuardService]
})



export class AppModule {
  constructor(public appRef: ApplicationRef) {}
  hmrOnInit(store) {
    console.log('HMR store', store);
  }
  hmrOnDestroy(store) {
    const cmpLocation = this.appRef.components.map((cmp) => cmp.location.nativeElement);
    // recreate elements
    store.disposeOldHosts = createNewHosts(cmpLocation);
    // remove styles
    removeNgStyles();
  }
  hmrAfterDestroy(store) {
    // display new elements
    store.disposeOldHosts();
    delete store.disposeOldHosts;
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/app.module.ts